<template>
  <div class="section-review-top-matter">
    <h1>{{ title }}</h1>
    <div class="box-divider"></div>
    <div class="section-review-instructions">
      <slot></slot>
    </div>
    <div class="box-divider">
      <span>{{ sectionTitle }}</span>
      <span
        v-if="isSimulationComplete"
      >
        ({{ flashcardListStatuses.length }} Questions, {{ tally.correct }} Correct, {{ flashcardListStatuses.length - tally.correct }} Incorrect, {{ flaggedCount }} Flagged)
      </span>
      <span
        v-else
      >({{ flashcardListStatuses.length }} Questions, {{ answeredCount }} Complete, {{ flashcardListStatuses.length - answeredCount }} Incomplete, {{ flaggedCount }} Flagged)</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    sectionTitle: {
      type: String,
      required: true,
    },
    flashcardListStatuses: {
      type: Array,
      required: true,
    },
    tally: {
      type: Object,
      required: true,
    },
    isSimulationComplete: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    answeredCount() {
      return this.flashcardListStatuses.filter(status => status.isAnswered).length;
    },
    flaggedCount() {
      return this.flashcardListStatuses.filter(status => status.isBookmarked).length;
    },
  },
};
</script>

<style lang='scss' scoped>
$sim-background-color: #00629E;

h1 {
  font-size: 20px;
  font-weight: 700;
  margin-block-start: 1.5rem;
  margin-block-end: 1.5rem;
  text-align: center;
}

.box-divider {
  height: 2rem;
  background-color: $sim-background-color;
  margin: 1.5rem 0;
  font-size: 14px;
  font-weight: 600;
  color: white;
  line-height: 2rem;
  display: flex;
  justify-content: space-between;
  padding: 0 1.25rem;
}

.section-review-instructions {
  line-height: 1.5rem;

  ol {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 1.5rem;
  }
}
</style>
